import log from './log';

const isValidUser = (user: string): boolean => {
  if (user === '00000000-0000-0000-0000-000000000000') {
    log(`invalid userId: ${user}`);
    return false;
  }
  return true;
};

export default isValidUser;
